import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for R211
// (實際進貨成本計算作業 / Actual Purchase Cost Calculation)
// ============================================================

export interface CalculateRequest {
  start_date: string; // ISO 8601 date string, must be first day of month (YYYY-MM-01T00:00:00Z)
}

export interface CalculateResponse {
  success: boolean;
  message: string;
  start_date: string; // ISO 8601
  end_date: string;   // ISO 8601 — auto-computed last day of month
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const r211Api = {
  /** Trigger actual purchase cost calculation for the given month */
  async calculate(startDate: string): Promise<CalculateResponse> {
    const res = await apiClient.post('/api/r211/calculate', {
      start_date: startDate,
    } as CalculateRequest);
    return res.data;
  },
};
